import {FC} from 'react';
import {
  ActionWrapper,
  IconWrapper,
  ToastData,
  ToastTitle,
  ToastWrapper,
} from './Toast.styles';
import {CheckmarkFilled, WarningFilled} from '@carbon/icons-react';
import {theme} from '@styles/theme';
import Text from '@atoms/Text';

interface ToastProps {
  type?: 'info' | 'warn' | 'success' | 'error';
  title?: string;
  text?: string;
  action?: () => void;
  actionText?: string;
}

const Toast: FC<ToastProps> = ({type = 'info', title, text, action, actionText}) => {
  return (
    <ToastWrapper type={type}>
      <IconWrapper type={type}>
        {(type == 'info' || type == 'success') && (
          <CheckmarkFilled
            size={21}
            color={type == 'info' ? theme.colors.basic04 : theme.colors.signalGreen00}
          />
        )}
        {(type == 'warn' || type == 'error') && (
          <WarningFilled
            size={21}
            color={
              type == 'warn' ? theme.colors.signalOrange00 : theme.colors.signalRed00
            }
          />
        )}
      </IconWrapper>
      <ToastData>
        <ToastTitle>
          {!!title && (
            <Text text={title || ''} type="bodyM" color={theme.colors.basic01} />
          )}
          {!!text && <Text text={text || ''} type="tinyR" color={theme.colors.basic02} />}
        </ToastTitle>
        {!!action && (
          <ActionWrapper onClick={action}>
            <Text text={actionText || ''} type="tinyR" color={theme.colors.accent00} />
          </ActionWrapper>
        )}
      </ToastData>
    </ToastWrapper>
  );
};

export default Toast;
